<template>
  <div class="box-card d-flex flex-column full-width">
    <div class="box-card-header">
      <div class="border-box">
        <slot name="header"
          ><h4>{{ title }}</h4></slot
        >
      </div>
    </div>
    <div class="box-card-content">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  box-shadow: var(--box-shadow);
  background-color: white;
  border: 1px solid var(--medium-color);
  border-radius: 5px;
}
.box-card-header {
  font-weight: bold;
  font-size: 1rem;
  padding: 0 0.75rem;
  margin-bottom: 0;
  flex-shrink: 0;
}

.border-box {
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.box-card-content {
  height: 100%;
}
</style>
